import React, { useStat, useRef, useEffect, useState } from 'react';

import { connect, useSelector, useDispatch} from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "../../../../../../../css/workspace.css";
import {
    Button,
    Tooltip,
    Input,
    Select,
    Dropdown,
    Checkbox
  } from "antd";
  import {
    DeleteTwoTone,
    PlusOutlined,
    TagsOutlined,
    SaveOutlined
  } from "@ant-design/icons";
  import {
    getWalkthroughs,
    updateWalkthroughs
  } from "../../../../../../../redux/actions/collectionsV2";
  import {
    getDraftSkills,
  } from "../../../../../../../redux/actions/skill";
  import { notify } from "../../../../../../../components/Snack";

const Walkthroughs = () => {

    const dispatch = useDispatch();
    const queryParams = useLocation().search;

    const collectionName =  new URLSearchParams(queryParams).get("name");

    const [searchWalkthroughText, setSearchWalkthroughText] = useState("");
    const [walkthroughFlag, setWalkthroughFlag] = useState(false);
    const [inAppWalkthroughData, setInAppWalkthroughData] = useState([]);
    const [walkthroughsSelected, setWalkthroughsSelected] = useState([]);
    const [walkthroughToDelete, setWalkthroughToDelete] = useState("");
    const [walkthroughsListTemp, setWalkthroughsListTemp] = useState([]);
    const [_walkthroughsList, _setWalkthroughsList] = useState([]);
    const [instruction, setInstruction] = useState("");

    const userDetails = useSelector(
        (state) => state.organizationReducer.currentOrganization
    );
    const walkthroughsList = useSelector(
        (state) => state.collectionReducer.walkthroughsData
    );
    let instructionList = useSelector(
        (state) => state.collectionReducer.instructionData
    );

    const onWalkThroughSelectionChange = (key, item) => {
        setWalkthroughsSelected(item);
    }

    useEffect(() => {
        _setWalkthroughsList(walkthroughsList);
        setInstruction(instructionList);
        setWalkthroughsListTemp(walkthroughsList);
    }, [walkthroughsList, instructionList]);

    const deleteWalkthrough = async (walkthroughToDelete) => {
        try {
          let walkthroughsPayload = _walkthroughsList.filter(function (obj) {
            return obj.id !== walkthroughToDelete;
          });
    
          let walkthroughResponse = await dispatch(
            updateWalkthroughs(
              collectionName,
              walkthroughsPayload
            )
          );
    
          if (walkthroughResponse?.status == 200) {
            dispatch(notify("success", "Walkthrough successfully deleted"));
            _setWalkthroughsList(walkthroughsPayload);
            // onSearch("");
            dispatch(getWalkthroughs(new URLSearchParams(queryParams).get("name")));
            setWalkthroughFlag(false);
          } else {
            dispatch(
              notify("error", "Walkthrough deletion failed. Please try again.")
            );
          }
        } catch {
          dispatch(notify("error", "Something went wrong. Please try again."));
        }
    };

    const saveWalkthrough = async () => {
        try {
          if (walkthroughsSelected?.length > 0) {
            setWalkthroughFlag(false);
            const walkthroughsPayload =
              walkthroughsList?.concat(walkthroughsSelected);
            let walkthroughResponse = await dispatch(
              updateWalkthroughs(
                collectionName,
                walkthroughsPayload
              )
            );
    
            if (walkthroughResponse?.status == 200) {
              dispatch(
                notify("success", "Walkthrough successfully added to collection")
              );
              _setWalkthroughsList(walkthroughsPayload);
              onSearchWalkthroughs("");
              dispatch(
                getWalkthroughs(collectionName)
              );
              setWalkthroughsSelected([]);
              setDropdownVisible(false);
            } else {
              dispatch(
                notify("error", "Walkthrough updation failed. Please try again.")
              );
            }
          } else {
            dispatch(notify("error", "Please select atleast one option"));
          }
        } catch {
          dispatch(notify("error", "Something went wrong. Please try again."));
        }
    };

    const getAvailableSkills = async () => {
        let data = { page: -1 };
        const userDraftSkill = await dispatch(getDraftSkills(data));
    
        let inAppWalkthroughSkills = userDraftSkill?.results?.filter(
          (skill) => skill.TEMPLATE === "In-App Walkthrough"
        );
    
        let inAppWalkthroughSkillsFiltered = inAppWalkthroughSkills.filter((el) => {
          return !_walkthroughsList.find((element) => {
            return element.id === el.id;
          });
        });
    
        if (inAppWalkthroughSkillsFiltered.length > 0) {
          let inAppWalkthroughDataArray = inAppWalkthroughSkillsFiltered?.map(
            (r) => ({
              label: r.SKILL_NAME,
              value: r.id,
              SKILL_NAME: r.SKILL_NAME,
              id: r.id,
              SKILL_DESCRIPTION: r.SKILL_DESCRIPTION,
              TEMPLATE: r.TEMPLATE,
              TYPE: r.TYPE,
              USER_EMAIL: r.USER_EMAIL,
              organizationId: r.organizationId,
              revision: r.revision,
              status: r.status,
              updated_at: r.updated_at,
            })
          );
    
          setInAppWalkthroughData(inAppWalkthroughDataArray);
        }
    };

    const onSearchWalkthroughs = async (value) => {
        setSearchWalkthroughText(value);
        let filter = "SKILL_NAME";
        let filteredData = walkthroughsListTemp.filter(function (obj) {
          return obj[filter]?.toLowerCase().match(value.toLowerCase());
        });
        _setWalkthroughsList(filteredData);
    };


    // Custom Walkthrough

    const [selectedItems, setSelectedItems] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [DropDownSelectedArray, setDropDownSelectedArray] = useState([]);

  // Toggle checkbox selection
  const handleCheckboxChange = (value, ele) => {
    setSelectedItems((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
    );
    const exists = DropDownSelectedArray.some(item => item.value === value);
    if (!exists) {
      setWalkthroughsSelected((current) => [ele, ...current])
    }
  };

  // Search input handler
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  // Filter options based on search
  const filteredOptions = inAppWalkthroughData?.filter((option) =>
    option.label.toLowerCase().includes(searchText.toLowerCase())
  );

  // Dropdown content
  const dropdownMenu = (
    <div className='dropBox'>
      <div className="search-submit">
        <Input
          placeholder="Search..."
          value={searchText}
          onChange={handleSearchChange}
          style={{ marginBottom: '10px' }}
        />
        <Tooltip placement="bottom" title="Save">
          <Button 
            onClick={() => saveWalkthrough()}
            type="primary" shape='circle' icon={<SaveOutlined />} 
        /></Tooltip>
      </div> 
      <div className="wlk-list-opt">
      {filteredOptions.map((option) => (
        <div key={option.value}>
          <Checkbox
            checked={selectedItems.includes(option.value)}
            onChange={() => handleCheckboxChange(option.value, option)}
          >
            {option.label}
          </Checkbox>
        </div>
      ))}
      </div>      
    </div>
  );

    // End of Custom Walkthrough


    return (
        <>
          <div className="wk-walkthroughs">
            <div className="csd-search-bar flex-search-btn">
              <Input
              size="small"
                value={searchWalkthroughText}
                placeholder="Search Walkthroughs"
                onChange={(e) => onSearchWalkthroughs(e.target.value)}
              />
                {/* <Button
                  onClick={() => {
                    walkthroughFlag
                      ? setWalkthroughFlag(false)
                      : setWalkthroughFlag(true);
                    getAvailableSkills();
                  }}
                  type="primary"
                  size="small"
                  icon={<PlusOutlined />}
                > Add Walkthroughs</Button> */}

              {/* Custom Walkthrogh Add */}
              <Dropdown
                overlay={dropdownMenu}
                trigger={['click']}
                visible={dropdownVisible}
                onVisibleChange={setDropdownVisible}
              >
                <Button
                  type="primary"
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    getAvailableSkills();
                  }}
                > Add Walkthroughs</Button>
              </Dropdown>

            </div>
  
            {walkthroughFlag ? (
              <div className="attach-wlk-block">
                <Select
                  mode="multiple"
                  allowClear
                  placeholder="Search Walkthroughs"
                  style={{
                    width: "100%",
                  }}
                  options={inAppWalkthroughData}
                  value={walkthroughsSelected}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={onWalkThroughSelectionChange}
                />
                <Button onClick={() => saveWalkthrough()} type="primary">
                  Save
                </Button>
              </div>
            ) : null}
  
  
              <div className="wk-manage-docs">
              
                      <ul className="wk-file-list">
                      {_walkthroughsList?.length > 0
              ? _walkthroughsList.map((obj, ind) => {
                return(
                          <li>
                            <div className="wk-file">
                              <div className="filelist-name">
                                <div className="wk-file-icon">
                                <TagsOutlined />
                                </div>
                                <p>{obj?.SKILL_NAME}</p>
                              </div>
                              
                              <div className="wk-file-delete">
                              {userDetails?.role_id == "2" ? (
                          <>
                            <Tooltip
                              title="Delete"
                              onClick={() => {
                                deleteWalkthrough(obj?.id);
                              }}
                            >
                              <DeleteTwoTone twoToneColor="#FF4646" />
                            </Tooltip>
                          </>
                        ) : null}                              
                              </div>
                            </div>
                          </li>
                        )
                    })
                    : null}
                      </ul>
                </div>
          </div>
        </>
    );

}
export default Walkthroughs;